import { Col, Container, Form, Row } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { connect } from "react-redux";
import Select from "../../../../components/AppSelect";
import { customStyles } from "../../utils/utils";
import { useGeneralInformation } from "../../hooks/useGeneralInformation";
import { useProductForm } from "../productModalForm";

const GeneralInformationFormComponent = ({
  rowEdited,
  shippers = [],
  categories = [],
  subCategories = [],
  reduxGetShippers = () => {},
  reduxGetCategories = () => {},
  reduxGetSubCategories = () => {}
}) => {
  const {
    control,
    formState: { errors },
    setValue
  } = useFormContext();

  const { isFM, disabled } = useProductForm();

  const {
    shippersOptions,
    categoriesOptions,
    subCategoriesOptions,
    presentationOptions,
    categorySelected,
    setCategorySelected,
  } = useGeneralInformation({
    rowEdited,
    shippers,
    categories,
    subCategories,
    reduxGetShippers,
    reduxGetCategories,
    reduxGetSubCategories

  });

  return (
    <Container>
      <h4>Información general</h4>
      <hr />
      <Row>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="shipperId" className="form-label">
            Remitente <span className="text-danger">*</span>
          </label>
          <Controller
            name="shipperId"
            control={control}
            rules={{
              required: "Es obligatorio seleccionar un remitente",
            }}
            render={({ field }) => (
              <Select
                {...field}
                placeholder="Seleccionar"
                className={`${!!errors?.shipperId && "is-invalid"}`}
                styles={customStyles}
                options={shippersOptions.filter(option => option.additionalInfo.isActive )}
                value={
                  field.value
                    ? shippersOptions.find(
                        (option) => option.value === field.value,
                      )
                    : null
                }
                onChange={(selectedOption) => {
                  field.onChange(selectedOption ? selectedOption.value : null);
                  setValue(
                    "currency",
                    selectedOption?.additionalInfo?.countryData?.currency || "",
                    {
                      shouldValidate: true,
                      shouldDirty: true,
                    },
                  );
                }}
              />
            )}
          />
          {!!errors?.shipperId && (
            <span className="error-message">
              {errors?.shipperId?.message || "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="presentation" className="form-label">
            Presentación{isFM && <span className="text-danger">*</span>}
          </label>
          <Controller
            name="presentation"
            control={control}
            rules={{
              required: isFM ? "Es obligatorio seleccionar una presentación" : false,
            }}
            render={({ field }) => (
              <Select
                {...field}
                placeholder="Seleccionar"
                className={`${!!errors?.presentation && "is-invalid"}`}
                styles={customStyles}
                options={presentationOptions}
                isDisabled={disabled}
                value={
                  field.value
                    ? presentationOptions.find(
                        (option) => option.value === field.value,
                      )
                    : null
                }
                onChange={(selectedOption) => {
                  field.onChange(selectedOption ? selectedOption.value : null);
                }}
              />
            )}
          />
          {!!errors?.presentation && (
            <span className="error-message">
              {errors?.presentation?.message || "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="categoryId" className="form-label">
            Categoría{isFM && <span className="text-danger">*</span>}
          </label>
          <Controller
            name="categoryId"
            control={control}
            rules={{
              required: isFM ? "Es obligatorio seleccionar una categoría" : false,
            }}
            render={({ field }) => (
              <Select
                {...field}
                placeholder="Seleccionar"
                className={`${!!errors?.categoryId && "is-invalid"}`}
                styles={customStyles}
                isDisabled={disabled}
                options={categoriesOptions}
                value={
                  field.value
                    ? categoriesOptions.find(
                        (option) => option.value === field.value,
                      )
                    : null
                }
                onChange={(selectedOption) => {
                  field.onChange(selectedOption ? selectedOption.value : null);
                  setCategorySelected(selectedOption.value);
                  setValue("subCategoryId", "");
                }}
              />
            )}
          />
          {!!errors?.categoryId && (
            <span className="error-message">
              {errors?.categoryId?.message || "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="subCategoryId" className="form-label">
            Subcategoría{isFM && <span className="text-danger">*</span>}
          </label>
          <Controller
            name="subCategoryId"
            control={control}
            rules={{
              required: isFM ? "Es obligatorio seleccionar una subcategoría" : false,
            }}
            render={({ field }) => (
              <Select
                {...field}
                placeholder="Seleccionar"
                className={`${!!errors?.subCategoryId && "is-invalid"}`}
                styles={customStyles}
                options={subCategoriesOptions}
                isDisabled={disabled || !categorySelected}
                value={
                  field.value
                    ? subCategoriesOptions.find(
                        (option) => option.value === field.value,
                      )
                    : null
                }
                onChange={(selectedOption) => {
                  if (!categorySelected) return;
                  field.onChange(selectedOption ? selectedOption.value : null);
                }}
              />
            )}
          />
          {!!errors?.subCategoryId && (
            <span className="error-message">
              {errors?.subCategoryId?.message || "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
      </Row>
    </Container>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxGetCountries: (payload) =>
      dispatch({
        type: "FETCH_COUNTRIES_REQUEST",
        value: payload,
      }),
    reduxGetShippers: (payload) =>
      dispatch({
        type: "FETCH_COMPANIESBYSHIPPER_REQUEST",
        value: payload,
      }),
    reduxGetCategories: (payload) =>
      dispatch({
        type: "FETCH_CATEGORIES_REQUEST",
        value: payload,
      }),
    reduxGetSubCategories: (payload) =>
      dispatch({
        type: "GET_ALL_ACTIVE_SUB_CATEGORIES_REQUEST",
        value: payload,
      }),
  };
};

const mapStateToProps = (state) => {
  return {
    rowEdited: state.productState.rowEdited,
    shippers: state.companyState.clients,
    categories: state.categoryState.categories,
    subCategories: state.subCategoriesState.subCategoriesActive,
  };
};

export const GeneralInformationForm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(GeneralInformationFormComponent);
